// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"1037b010","207":"d6a0f511","939":"81c344c6"}[chunkId] + ".chunk.css";
};